import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { TextField, Button, Box, Typography } from "@mui/material";
import axios from "axios";
import { API } from "../../pages/backend";
import { toast } from "react-toastify";

const ResetPasswordRequest = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const examType = queryParams.get("examType");
  const examCode = examType === "MODEL SCREENING EXAMINATION" ? "01" : "02";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter your email address!",
      });
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        `${API}/individual/password/forgot?assessmentCode=${examCode}`,
        { email }, 
        {
          headers: {
            "Content-Type": "application/json", // ✅ Correct headers
          },
        }
      );

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Email Sent!",
          text: `A password reset link has been sent to ${email}. Please check your inbox.`,
        });

        setEmail(""); // ✅ Clear input after success
      }
    } catch (error) {
      if (error?.response) {
        toast.error(error?.response?.data?.message || "Something went wrong!");
      } else {
        toast.error("Network error! Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        mx: "auto",
        p: 4,
        mt: 6,
        bgcolor: "white",
        boxShadow: 3,
        borderRadius: 2,
        textAlign: "center",
      }}
    >
      <Typography variant="h5" fontWeight="bold" mb={3}>
        Forgot Password?
      </Typography>
      <Typography variant="h6" fontWeight="bold" mb={3}>
        {examType}
      </Typography>

      <Typography variant="body2" color="textSecondary" mb={2}>
        Enter your email below, and we'll send you a link to reset your password.
      </Typography>

      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Email Address"
          type="email"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          sx={{ mb: 3 }}
        />

        <Button type="submit" variant="contained" color="success" fullWidth disabled={loading}>
          {loading ? "Sending..." : "Send Reset Link"}
        </Button>
      </form>

      <Button
        variant="outlined"
        color="secondary"
        fullWidth
        sx={{ mt: 2 }}
        onClick={() => navigate(-1)}
        disabled={loading}
      >
        Go Back
      </Button>
    </Box>
  );
};

export default ResetPasswordRequest;
